import { render } from "./prepare-deals.vue?vue&type=template&id=704a8d5b&scoped=true&ts=true"
import script from "./prepare-deals.vue?vue&type=script&lang=ts"
export * from "./prepare-deals.vue?vue&type=script&lang=ts"

import "./prepare-deals.vue?vue&type=style&index=0&id=704a8d5b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704a8d5b"]])

export default __exports__